import { Injectable } from "@angular/core";
import { NotificationMessagePayload } from "src/app/shared/store/notification/notification.actions";
import { QuoteFeatureState } from "src/app/shared/store/quote/pillar-3a/quote.state";
import { NotificationMessage } from "../../../../store/notification/notification.state";

@Injectable({
  providedIn: "root",
})
export class NotificationQuoteService {
  createNotificationPayloads(
    _previousQuoteFeatureState: QuoteFeatureState,
    _currentQuoteFeatureState: QuoteFeatureState,
    _: NotificationMessage[] | undefined,
  ) {
    return [] as NotificationMessagePayload[] | undefined;
  }
}
